<template>
  <section id="people" class="o-section c-people" v-my-section-class>

    <!-- Background -->
    <div class="o-background" v-if="$store.state.device !== 0">
      <div class="o-background__inner" :class="{'o-background__inner--fade': slideIndex !== 0 || tabIndex === 1}">
        <my-circle class="o-background__item o-background__item--1" :image-file="'people/trailblazers'" :variant="1"></my-circle>
        <my-circle class="o-background__item o-background__item--2" :image-file="'people/black-asian-ethnic'"></my-circle>
        <my-circle class="o-background__item o-background__item--3" :image-file="'people/women'"></my-circle>
      </div>
    </div>

    <!-- Content -->
    <div class="o-section__container">
      <h2 class="o-section__title">Our people</h2>

      <my-tabs @tab-changed="setTabIndex">

        <!-- TAB -->
        <my-tab title="Our people" :is-active="true">
          <my-slider @slide-changed="setSlideIndex" :defer="true">
            <my-slide :key="item.slug" v-for="(item, index) in peopleItems">
              <div class="o-panel__header">
                <h3 class="o-panel__title">{{ item.title }}</h3>
              </div>
              <div class="o-panel__body" v-html="item.body"></div>
              <div class="o-panel__footer">
                <my-circle :image-file="'people/' + item.slug" :variant="1" v-if="index !== 0"></my-circle>
                <div class="o-link__btn-group u-extra-space-below" v-if="index === 0">
                  <my-download-button :section="'people'"></my-download-button>
                </div>
              </div>
            </my-slide>
          </my-slider>
        </my-tab>

        <!-- TAB -->
        <my-tab title="Awards">
          <my-tab-inner>
            <div class="o-panel__header">
              <h3 class="o-panel__title">Accreditations and Awards</h3>
              <p class="o-panel__subtitle">Our accreditations and awards won this year include:</p>
            </div>
            <div class="o-panel__body o-panel__body--full">
              <div class="o-grid o-grid--3 o-grid--thin o-grid--awards">
                <div class="o-grid__item o-award" v-for="(item, index) in awardItems">
                  <figure class="o-award__image">
                    <img :src="require('@/assets/images/logos/' + item.slug + '.png')" :srcset="require('@/assets/images/logos/' + item.slug + '.png') + ' 1x, ' + require('@/assets/images/logos/' + item.slug + '@2x.png') + ' 2x'" width="256" height="192" :alt="item.slug">
                  </figure>
                  <div class="o-award__text" v-html="item.body"></div>
                </div>
              </div>
            </div>
          </my-tab-inner>
        </my-tab>
      </my-tabs>
    </div>
  </section>
</template>

<script>
import { MySectionClass } from '@/directives/my-section-class'
import { MyTabs, MyTab, MyTabInner } from '@/components/standard/my-tabs'
import { MySlider, MySlide } from '@/components/standard/my-slider'
import MyDownloadButton from '@/components/standard/my-download-button'
import MyCircle from '@/components/standard/my-circle'
import mixins from '@/mixins'

export default {
  name: 'my-people',
  components: {
    MyTabs,
    MyTab,
    MyTabInner,
    MySlider,
    MySlide,
    MyCircle,
    MyDownloadButton
  },
  mixins: [mixins],
  computed: {
    peopleItems () {
      return this.$store.state.content['people'] || []
    },
    awardItems () {
      return this.$store.state.content['awards'] || []
    }
  },
  directives: {
    MySectionClass
  },
  methods: {
  },
  mounted () {
    // this.rellax = new Rellax('.rellax', {
    //   center: true
    // })
  }
}
</script>



// WEBPACK FOOTER //
// MyPeople.vue?0a1b6976